<template>
  <div v-if="isHelpModalOpen" class="helpModal">
    <div class="helpModal-background" @click="closeHelpModal"></div>
    <div class="helpModal-content">
      <h5 class="title is-5">AI Mode</h5>
      <br />
      <h5 class="title is-5">1. Above the Ceiling</h5>
      <p>
        A detection method focusing on the movement of pests. *Default setting
      </p>
      <p>
        ・ Advantage: Relatively large objects (such as workers above the
        ceiling) are not detected.
      </p>
      <p>
        ・ Disadvantage: There is a possibility of missing pests that appear
        large in the view.
      </p>
      <br />
      <h5 class="title is-5">2. Attic (High Sensitivity)</h5>
      <p>
        A detection method focusing on the movement of pests, where detection is
        enabled even for relatively large objects.
      </p>
      <p>
        Recommended for cases where false detections are acceptable, but missing
        detections should be avoided as much as possible.
      </p>
      <p>・ Advantage: Detects pests that appear large in the view.</p>
      <p>
        ・ Disadvantage: Relatively large objects (such as workers above the
        ceiling) are also detected.
      </p>
      <br />
      <h5 class="title is-5">3. Work Space</h5>
      <p>A detection method emphasizing the shape of pests.</p>
      <p>
        Recommended for cases where reducing false detections is a priority.
      </p>
      <p>・ Advantage: Reduces false detections caused by humans or objects.</p>
      <p>・ Disadvantage: Increases the likelihood of missed detections.</p>
      <br />
      <button @click="closeHelpModal" class="button is-danger ml-3">
        Close
      </button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "UndetectedAreaEn",
  props: {
    isHelpModalOpen: Boolean,
  },
  emits: ["close"],
  setup(props, { emit }) {
    const closeHelpModal = () => {
      emit("close");
    };
    return { closeHelpModal };
  },
});
</script>

<style>
.helpModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  overflow-x: scroll;
}

.helpModal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

.helpModal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
